import Icon from "@imminently/decisively-ui/Icon";
import { priorityColor, statusColor, statusTextColor } from "./taskUtils";
import { TaskPriority, TaskStatus } from "@packages/commons";
import { useTranslation } from "react-i18next";
import Chip from "@imminently/decisively-ui/Chip";

// allowing generic string as TS is too annoying to bother with this

export const StatusLabel = ({ status }: { status: TaskStatus }) => {
  const { t } = useTranslation();
  return (
    <Chip
      size="sm"
      className="capitalize"
      backgroundColor={statusColor[status]}
      color={statusTextColor[status]}
      label={t(`tasks.status.${status}`)}
    />
  );
};

export const PriorityLabel = ({ priority }: { priority: TaskPriority }) => {
  const { t } = useTranslation();
  return (
    <div className={"flex items-center gap-2"}>
      <Icon name="flag" style={{ color: priorityColor[priority] }} />
      <span>{t(`tasks.priority.${priority}`)}</span>
    </div>
  );
};
